exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Tip {\n  background: white;\n  border-radius: 5px;\n  padding: 10px 20px;\n  max-width: 256px;\n  position: fixed;\n  z-index: 15;\n  -webkit-transition: opacity 1s;\n  -o-transition: opacity 1s;\n  transition: opacity 1s; }\n  .Tip .Text {\n    margin: 0; }\n  .Tip.Hide {\n    opacity: 0; }\n  .Tip[cursor]:after {\n    content: '';\n    width: 15px;\n    height: 15px;\n    background: white;\n    position: absolute;\n    -webkit-transform: rotate(45deg);\n        -ms-transform: rotate(45deg);\n            transform: rotate(45deg); }\n  .Tip[cursor=up-right]:after {\n    top: -6px;\n    right: 15px; }\n  .Tip[cursor=down-right]:after {\n    bottom: -6px;\n    right: 15px; }\n  .Tip[cursor=right-down]:after {\n    right: -6px;\n    bottom: 15px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/Tour/Tip/Tip.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/pages/Tour/Tip/Tip.css
// module chunks = 0